import {createSlice} from "@reduxjs/toolkit";
import {getRefunds} from './action'

const initialState = {
  state: {
    refunds: [],
    paging: null
  },
  loading: true,
  error: ''
} as BaseState<RefundState>

const slice = createSlice({
  name: 'refundSummarySlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRefunds.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getRefunds.fulfilled, (state, action) => {
      const { items, paging } = action.payload
        return {
          ...state,
          state: {
            paging,
            refunds: items
          },
          error: '',
          loading: false
        }
      })
    builder.addCase(getRefunds.rejected, (state) => ({
      ...state,
      error: 'Failed to get refund summary data',
      loading: false
    }))
  }
})

export default slice
